<template>
    <section class="statistic-section">
      <div class="container">
        <div class="statistic-box">
          <div class="row">
            <div class="col-lg-3 col-md-6" v-for="(item, index) in data.post">
              <div class="statistic-post">
                <p><span class="timer" data-from="0" :data-to="item.value"></span></p>
                <h2>{{item.title}}</h2>
              </div>
            </div>
    
          </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: 'Statistic',
 props: {
    data: Object
  },
  mounted: function(){
  /*-------------------------------------------------*/
  /* =  count increment
  /*-------------------------------------------------*/
  try {
    $('.statistic-post').appear(function() {
      $('.timer').countTo({
        speed: 4000,
        refreshInterval: 60,
        formatter: function (value, options) {
          return value.toFixed(options.decimals);
        }
      });
    });
  } catch(err) {

  }
  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
